(function ($) {
  const KEY_ENTER = 13;
  const KEY_SPACE = 32;

  $("a.uk-navbar-toggle").on("click", function () {
    // switch the background color to white colour
    $(".header-container").toggleClass("mobile-white-header");

    // Prevent scrolling when menu is open
    $("body").toggleClass("no-scroll");

    // Remove the pink location dropdown
    $(".top-location-container").toggleClass("uk-hidden");
  });

  $(".nav-primary .primary-header-menu .main-menu-item.menu-item-has-children").on('keydown', function(e) {
    if( e.which === KEY_ENTER || e.which === KEY_SPACE ) {
      $(this).find(".uk-navbar-dropdown > ul > li:first-child > a").focus();
    }
  });

  $(".consultation-btn a").each( function() {
    $( this ).attr("target","_blank");
  });
})(jQuery);
